import { Radio, Select } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import { Text } from "@components/Text";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";

import { LOREM_IPMS } from "./LOR";

const { Group: RadioGroup } = Radio;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 12px;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ScrollBox = styled.div`
  flex: 1;
  /* background: rgb(0 204 153 / 10%); */
  border: 1px solid #0c9;
  border-radius: 8px;
  padding: 8px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const OPTION_STATUS = [
  { label: "DEVICES", value: "DEVICES" },
  { label: "GROUPS", value: "GROUPS" },
];

const ContainerDeviceBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 8px;
`;

const DeviceBox = styled(Button)`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  padding: 8px;
  box-sizing: border-box;

  background: white;
  border: 1px solid;
  border-color: ${({ isActive = false }) => (isActive ? "#0c9" : "#ccc")};
  border-radius: 8px;
  overflow: hidden;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const FormLink = ({
  locationId,
  customerId,
  importantId,
  setIsModalVisible,
}) => {
  const [isReady, setIsReady] = useState(false);

  const [filterOptions, setFilterOptions] = React.useState(
    OPTION_STATUS[0].value
  );

  const [linkImportantDevices, setLinkImportantDevices] = useState(null);
  const [deviceGroupList, setDeviceGroupList] = useState(null);
  const [deviceList, setDeviceList] = useState(null);
  const [renderDeviceList, setRenderDeviceList] = useState(null);

  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedDeviceGroups, setSelectedDeviceGroups] = useState(null);

  const refactorDropdownOptions = (deviceGroups) => {
    const result = _.map(deviceGroups, (item) => {
      return { label: item?.name, value: item?.id };
    });

    return result;
  };

  const initial = async () => {
    try {
      setIsReady(false);
      console.log("customerId :>> ", customerId);
      console.log("locationId :>> ", locationId);
      console.log("importantId :>> ", importantId);

      const resp = await fetchAPI({
        method: "post",
        path: "/api/v2/get-important-devices",
        data: { importantId, locationId },
      });

      if (_.get(resp, ["status"])) {
        const deviceList = _.get(resp, ["result", "deviceList"]);
        const deviceGroups = _.get(resp, ["result", "deviceGroups"]);
        console.log("deviceGroups :>> ", deviceGroups);
        const importantLinkDevices = _.get(resp, [
          "result",
          "importantLinkDevices",
        ]);
        const dropdownOptions = refactorDropdownOptions(deviceGroups);
        setDropdownOptions(dropdownOptions);
        setDeviceList(deviceList);
        setRenderDeviceList(deviceList);
        setDeviceGroupList(deviceGroups);
        setLinkImportantDevices(importantLinkDevices);
      }
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      setIsReady(true);
    }
  };

  useEffect(() => {
    initial();
  }, []);

  const handleSelectFilter = ({ value }) => {
    setFilterOptions(value);
    setSelectedDeviceGroups(null);
    setRenderDeviceList(deviceList);
  };

  const handleSelectedDeviceGroup = ({ value }) => {
    console.log("value :>> ", value);
    setSelectedDeviceGroups(value);
    const deviceGroupKey = _.keyBy(deviceGroupList, "id");
    console.log("deviceGroupKey :>> ", deviceGroupKey);
    const renderDeviceList = _.chain(deviceGroupKey)
      .get([value, "deviceGroupsDetails"])
      .map((item) => {
        return { ...item?.device };
      })
      .value();
    console.log("renderDeviceList :>> ", renderDeviceList);
    setRenderDeviceList(renderDeviceList);
    // console.log("deviceList :>> ", deviceList);
  };

  const handleSelectDevice = ({ item }) => {
    const deviceId = _.get(item, "id");
    const linkItem = {
      location_id: _.get(item, ["location_id"]),
      customer_id: _.get(item, ["category_customer_id"]),
      important_campaign_id: importantId,
      device_id: deviceId,
    };

    setLinkImportantDevices((prev) => {
      const isAlreadySelected = _.some(prev, { device_id: deviceId });
      const updated = _.chain(prev)
        .thru((list) => {
          return isAlreadySelected
            ? _.filter(list, (item) => item.device_id !== deviceId)
            : [...list, linkItem];
        })
        .value();

      return updated;
    });
  };

  const handleSubmit = async () => {
    try {
      setIsReady(false);
      const removeLinkImportantDevices = _.map(linkImportantDevices, (item) => {
        return _.get(item, ["device_id"]);
      });
      console.log(
        "removeLinkImportantDevices :>> ",
        removeLinkImportantDevices
      );
      const resp = await fetchAPI({
        method: "post",
        path: "/api/v2/update-important-link-devices",
        data: { importantId, linkImportantDevices, removeLinkImportantDevices },
      });

      if (_.get(resp, ["status"])) {
        setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
        toast.success("Update important link Success.");
      }
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      setIsReady(true);
    }
  };

  return (
    <FormContainer>
      <Header>
        <Text fontWeight="500">Filter By:</Text>
        <RadioGroup
          options={OPTION_STATUS}
          optionType="button"
          value={filterOptions}
          onChange={(e) => {
            handleSelectFilter({ value: e.target.value });
          }}
        />
        {filterOptions === "GROUPS" && (
          <div style={{ flex: 1 }}>
            <Select
              size="middle"
              showSearch
              placeholder="Select a group"
              optionFilterProp="children"
              style={{ width: "100%" }}
              filterOption={(input, option) =>
                (option?.label ?? "").includes(input)
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={dropdownOptions}
              onChange={(value) => {
                handleSelectedDeviceGroup({ value });
              }}
            />
          </div>
        )}
      </Header>

      <ScrollBox>
        <ContainerDeviceBox>
          {_.map(renderDeviceList, (item, index) => {
            const deviceId = _.get(item, ["id"]);
            const linkedDeviceKey = _.keyBy(linkImportantDevices, "device_id");
            const isActive = _.has(linkedDeviceKey, deviceId);
            return (
              <DeviceBox
                isActive={isActive}
                key={index}
                type="button"
                onClick={() => handleSelectDevice({ item })}
              >
                <Text
                  fontSize={"12px"}
                  isEllipsis
                  lines={1}
                  fontWeight={isActive ? "500" : "400"}
                  color={isActive ? "#0c9" : "black"}
                >
                  {item?.name}
                </Text>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    fontSize={"10px"}
                    isEllipsis
                    lines={1}
                    fontWeight={isActive ? "600" : "500"}
                    color={isActive ? "#0c9" : "black"}
                  >
                    {`w: ${item?.screen_width}`}
                  </Text>
                  <Text
                    fontSize={"10px"}
                    isEllipsis
                    lines={1}
                    fontWeight={isActive ? "600" : "500"}
                    color={isActive ? "#0c9" : "black"}
                  >
                    {`h: ${item?.screen_height}`}
                  </Text>
                </div>
              </DeviceBox>
            );
          })}
          {/* {Array.from({ length: 2 }).map((_, index) => (
            <DeviceBox key={index}>Device {index + 1}</DeviceBox>
          ))} */}
        </ContainerDeviceBox>
        {/* {LOREM_IPMS} */}
        {/* {LOREM_IPMS} */}
      </ScrollBox>

      <ButtonContainer>
        <Button
          onClick={() => handleSubmit()}
          type="button"
          color={COLOR_GREEN}
          fontColor={COLOR_WHITE}
          fontSize="16px"
          padding="5px 20px"
        >
          Save
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};
